import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function NotFound() {
 const { locale } = useLanguage();
 const l = (fr, en, pt) => locale === "en" ? en : locale === "pt" ? pt : fr;
 return (
 <div
 data-testid="page-not-found"
 className="min-h-[70vh] flex flex-col items-start justify-center mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14"
 >
 <div className="label-overline text-nanda-muted">404</div>
 <h1 className="font-serif text-6xl md:text-8xl mt-4">{l("Page introuvable", "Page not found", "Página não encontrada")}</h1>
 <Link
 to="/"
 data-testid="not-found-home"
 className="mt-10 inline-flex bg-nanda-ink text-nanda-bg px-7 py-4 label-overline hover:bg-nanda-inkSoft transition-colors"
 >
 {l("Retour à l'accueil", "Back to home", "Voltar ao início")}
 </Link>
 </div>
 );
}
